import type { Moment } from '@this/src/lib/moment';
import moment from '@this/src/lib/moment';
import type OrderItemStepTodo from './order_item_step_todo';
import type OrderItemStepTime from '../order_item/order_item_step_time';

const segmentElapsedSeconds = (stepTime: OrderItemStepTime, at: Moment): number => {
  if (stepTime.finishedAt) {
    return Math.floor(moment.duration(stepTime.finishedAt.diff(stepTime.startedAt)).asSeconds());
  }
  return Math.floor(moment.duration(at.diff(stepTime.startedAt)).asSeconds());
};

export const computeOrderItemStepElapsedSeconds = (
  stepTimes: OrderItemStepTime[],
  at: Moment = moment()
): number => {
  if (stepTimes.length === 0) {
    return 0;
  }

  const completedTimes = stepTimes.filter(stepTime => stepTime.finishedAt);
  const openTimes = stepTimes.filter(stepTime => !stepTime.finishedAt);
  const activeOpenTime = openTimes.length > 0 ? openTimes[openTimes.length - 1] : null;

  const completedTotal = completedTimes.reduce(
    (total, stepTime) => total + segmentElapsedSeconds(stepTime, at),
    0
  );

  if (!activeOpenTime) {
    return completedTotal;
  }

  return completedTotal + segmentElapsedSeconds(activeOpenTime, at);
};

export const getOrderItemStepTimesFromTodo = (todo: OrderItemStepTodo): OrderItemStepTime[] => {
  return todo.orderItemStepSequence?.currentStep?.orderItemStepTimes ?? todo.step?.orderItemStepTimes ?? [];
};

export const computeOrderItemStepElapsedSecondsFromTodo = (
  todo: OrderItemStepTodo,
  at: Moment = moment()
): number => {
  const stepTimes = getOrderItemStepTimesFromTodo(todo);
  if (stepTimes.length > 0) {
    return computeOrderItemStepElapsedSeconds(stepTimes, at);
  }
  if (todo.startedAt) {
    return Math.floor(moment.duration(at.diff(todo.startedAt)).asSeconds());
  }
  return todo.duration ?? 0;
};
